<script>
// CommitChart.js
import {Line} from 'vue-chartjs'
import Utils from "../../scripts/utils";

export default {
    extends: Line,
    data() {
        return {
            lastData: this.data
        }
    },
    props: {
        labels: {
            required: true,
            type: Array
        },
        unit: {
            type: String,
            default: ''
        },
        digits: {
            type: Number,
            default: 0
        },
        data: {
            required: true,
            type: Array
        },
        width: {
            default: Utils.calcColWidth(),
            type: Number
        },
        height: {
            default: 300,
            type: Number
        },
        title: {
            type: String,
            default: ''
        }
    },
    mounted() {
        this.renderLineChart(false);
        window.addEventListener('resize', function () {
            this.reRender(false)
        }.bind(this));
    },
    computed: {
        chartData: function () {
            return this.data;
        },
        w() {
            return Utils.getCurrentBreakpoint() === 'lg' ? Utils.calcColWidth * 2 - 60 : Utils.calcColWidth;
        },
        h() {
            return Utils.calcColWidth * 0.8;
        }
    },
    methods: {
        renderLineChart: function (animated = false) {
            if (this.$refs.canvas) {
                this.$refs.canvas.style['max-width'] = this.w + 'px';
                this.$refs.canvas.style['max-height'] = this.h + 'px';
            }
            const options = {
                //responsive: false,
                //  maintainAspectRatio: false,
                animation: {
                    duration: animated ? 1000 : 0
                },
                legend: {
                    display: false,
                },
                tooltips: {
                    callbacks: {
                        title: function (tooltipItems) {
                            return typeof tooltipItems[0] !== 'undefined' ? tooltipItems[0].label : '';
                        }.bind(this),
                        label: function (tooltipItem, data) {
                            let number = data['datasets'][0]['data'][tooltipItem['index']]
                            number = parseFloat(number);
                            number = number.toLocaleString('de-DE', {
                                minimumFractionDigits: this.digits,
                                maximumFractionDigits: this.digits
                            });
                            return number + ' ' + this.unit;
                        }.bind(this)
                    }
                },
                scales: {
                    yAxes: [

                        {
                            ticks: {
                                callback: function (label) {
                                    label = parseFloat(label);
                                    let digits = this.unit === "€" && label < 0 ? 2 : 0
                                    label = label.toLocaleString('de-DE', {
                                        minimumFractionDigits: digits,
                                        maximumFractionDigits: digits
                                    });
                                    return label + ' ' + this.unit;
                                }.bind(this),
                                beginAtZero: true,
                                fontStyle: 'bold'
                            }
                        }],
                    xAxes: [{
                        ticks: {
                            fontStyle: 'bold'
                        }
                    }]
                },
                title: {
                    display: this.title !== '',
                    text: this.title,
                    fontSize: 12
                },
            };
            // Overwriting base render method with actual data.
            this.renderChart({
                labels: this.labels,
                datasets: [
                    {
                        lineTension: 0,
                        borderColor: '#00b6ed',
                        pointBackgroundColor: '#00b6ed',
                        backgroundColor: 'rgba(0,0,0,0)',
                        pointBorderWidth: 5,
                        borderWidth: 2,
                        data: this.data
                    }
                ]
            }, options)
        },
        arrayDiff(a, b) {
            return [...b.reduce((acc, v) => acc.set(v, (acc.get(v) || 0) - 1),
                a.reduce((acc, v) => acc.set(v, (acc.get(v) || 0) + 1), new Map())
            )].reduce((acc, [v, count]) => acc.concat(Array(Math.abs(count)).fill(v)), []);
        }
        ,
        reRender(animated) {
            this._data._chart.destroy();
            this.renderLineChart(animated);
        }
    },
    watch: {
        data: function () {
            if (this.arrayDiff(this.data, this.lastData).length > 0) {
                this.lastData = this.data;
                this.reRender(true);
            }
        }
    }

}
</script>

<style scoped>

canvas {
    background-color: white;
    padding: 12px;
    margin: auto;

}


</style>